import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { PatientAutosuggestItem } from './PatientAutosuggestItem';

export const patientLabelExtractor = (patient: PatientSimple): string => {
   const name = `${patient.lastName ?? ''} ${patient.firstName ?? ''}`.trim();
   if (name) {
      return name;
   }

   const externalIdentifier = patient.referenceIdentifier?.findExternalIdentifier();
   const patientPesel = externalIdentifier?.accept<string | null>({
      visitPesel: (pesel) => pesel.asString(),
      visitGuardianPesel: () => null,
      visitPassport: () => null,
      visitNationalIdentificationNumber: () => null,
   });

   if (patientPesel) {
      return patientPesel;
   }

   if (patient.phoneNumber) {
      return patient.phoneNumber.asString();
   }

   return '';
};

export const patientItemRenderer = (patient: PatientSimple): JSX.Element => (
   <PatientAutosuggestItem patient={patient} />
);
